import { useState, useCallback } from "react";

interface AlertState {
  visible: boolean;
  title: string;
  message?: string;
  emoji?: string;
  buttonLabel?: string;
  buttonColor?: string;
}

export function useAlert() {
  const [state, setState] = useState<AlertState>({
    visible: false,
    title: "",
  });

  const alert = useCallback(
    (opts: {
      title: string;
      message?: string;
      emoji?: string;
      buttonLabel?: string;
      buttonColor?: string;
    }): Promise<void> => {
      return new Promise((resolve) => {
        setState({
          visible: true,
          ...opts,
        });
        // Store resolve to call on close
        closeResolveRef = resolve;
      });
    },
    []
  );

  let closeResolveRef: (() => void) | null = null;

  const close = useCallback(() => {
    setState((s) => ({ ...s, visible: false }));
    if (closeResolveRef) closeResolveRef();
  }, []);

  return {
    alertProps: {
      visible: state.visible,
      title: state.title,
      message: state.message,
      emoji: state.emoji,
      buttonLabel: state.buttonLabel,
      buttonColor: state.buttonColor,
      onClose: close,
    },
    alert,
  };
}
